import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

function PlusProfileImage(props) {
  let navigate = useNavigate();
  const routeChange = () => {
    navigate("/addProfile");
  };

  const pStyle = {
    border: "2px solid #fff",
    borderRadius: "50%",
    textAlign: "center",
    height: "50px",
    width: "50px",
    fontSize: "36px",
    backgroundColor: "#040d41",
    color: "#fff",
    margin: "auto",
    overflow: "hidden",
  };
  const nStyle = {
    padding: "7px",
    verticalAlign: "top",
  };
  const labelS = {
    textAlign: "center",
    color: "#040d41",
    fontWeight: "900",
    fontSize: "1vw",
    padding: "5px",
    width: "60px",
  };
  return (
    <div onClick={routeChange}>
      <div style={pStyle}>
        <FontAwesomeIcon icon={faPlus} style={nStyle} />
      </div>
      <div style={labelS}>New</div>
    </div>
  );
}

export default PlusProfileImage;
